module.exports = __webpack_public_path__ + "static/media/dBanner1.228fc697.png";